import React from 'react'

const About = () => {
    return (
        <div className='container mx-auto'>
            <div className="text-4xl mt-4 font-semibold">About</div>
            <div className='text-xl py-2'>
                Explore, search and locate Github Jobs.
            </div>
            <div className='font-hairline py-2'>
                React | Tailwind | Github Jobs API
            </div>
        </div>
    )
}

export default About
